import {
  newsEditionStateSchema,
  type NewsEditionSignal,
  type NewsEditionState,
} from '@secretario/shared';
import { apiFetch } from './http.js';

export const NEWS_EDITION_KEY = ['news-edition'] as const;

export async function getNewsEdition(): Promise<NewsEditionState> {
  return newsEditionStateSchema.parse(await apiFetch<unknown>('/v1/news/edition'));
}

/** Abriu ou pediu "mais disso": a próxima edição dá mais espaço ao assunto. */
export async function sendNewsSignal(signal: NewsEditionSignal): Promise<void> {
  await apiFetch<unknown>('/v1/news/edition/signal', { method: 'POST', body: signal });
}
